import React, { useState, useContext } from "react";
import { Card, Form, Button, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Policy from "./Policy";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showSweetAlert } from '../components/SweetAlert';

const Login = () => {
    const location = useLocation();
    const initialEmail = location.state?.email || '';
    const [passwordShown, setPasswordShown] = useState(false);
    const [email, setEmail] = useState(initialEmail);
    const [password, setPassword] = useState('');
    const [trustDevice, setTrustDevice] = useState(false);
    const [errors, setErrors] = useState({ email: '', password: '', invalid: '' });
    const [supporterrors, setSupportErrors] = useState({ issueType: '', description: '' });
    const [showPolicy, setShowPolicy] = useState(false);
    const { login, setUserData, supportEmail } = useContext(AuthContext);
    const [loading, setLoading] = useState(false); // Loading state
    const [showContactUs, setShowContactUs] = useState(false); // Loading state
    const navigate = useNavigate();
    const [showSupport, setShowSupport] = useState(false);
    const [issueType, setIssueType] = useState('');
    const [description, setDescription] = useState('');
    const [name, setName] = useState("");

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    const handleShowSupport = () => {
        setErrors({ email: '', password: '', invalid: '' }); // Clear login form errors
        setShowSupport(true); // Show the support modal
    };
    const handleCloseSupport = () => setShowSupport(false);

    const handleSupportSubmit =async (event) => {
        event.preventDefault();
    
        let valid = true;
        let newErrors = { ...supporterrors };
    
        if (!issueType) {
            console.log('no email');
            newErrors.issueType = 'Select any one issue';
            valid = false;
        } else if (!description) {
            console.log('no email');
            newErrors.description = 'Description is required.';
            valid = false;
        }else {
            newErrors.issueType = '';
            newErrors.description = '';
        }
        setSupportErrors(newErrors);
    
        console.log('Submitting issue:', {
        issueType,
        description,
        });
    
        if (valid) {
            const response = await supportEmail(issueType, description);
            if(response?.message === "Email sent successfully."){
                handleCloseSupport(); 
                showSweetAlert('Success!', `Email send Successfully.`, 'success');
            }
            else{
            showSweetAlert('Warning!', `Email address is not verified.`, 'warning');
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrors({ email: '', password: '', invalid: '' });
    
        // Check required fields
        if (!email || !password) {
            setErrors({ ...errors, invalid: 'Email and Password are required.' });
            return;
        }

        // Check if email is restricted
        const normalizedEmail = email.toLowerCase().trim();
        if (normalizedEmail === 'jkohake@gmail.com') {
            setErrors({ ...errors, invalid: 'This email is not allowed to access this application.' });
            return;
        }
    
        setLoading(true); // Set loading to true when API call starts
    
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
                email,
                password
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    
            const data = response.data;
    
            if (response.status === 200 && data.accessToken) {
                // navigate('/pricing-plans', { state: { email: data.userEmail } });

                const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${data.userId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${data.accessToken}`,
                    },
                });
                let userName = response.data.name
                login(data.accessToken, data.refreshToken, data.userId, userName);
                setUserData(response.data);
                setName(response.data.name);
                if(response.data.account_status === 'in_progress'){
                    showSweetAlert('Warning!', `Your account is in progress. Please try again later.`, 'warning');
                    console.log('Warning');
                    
                    return;
                }
                else if(response.data.account_status === 'signed_up'){
                    showSweetAlert('Warning!', `Your account is being set up. Please try again later.`, 'warning');
                    console.log('Warning');
                    
                    return;
                }
                else if(response.data.account_status === 'setup_failed'){
                    showSweetAlert('Error!', `Failed to setup the account. Please try again later.`, 'error');
                    setShowContactUs(true);
                    console.log('Error');
                    
                    return;
                }
                else if(response.data.account_status === 'update_failed'){
                    showSweetAlert('Warning!', `Your account is being set up. Please try again later.`, 'warning');
                    setShowContactUs(true);
                    console.log('Error');
                    
                    return;
                }
                else if(response.data.account_status === 'setup_done'){
                    console.log('setup_done');
                    localStorage.setItem('subDomain', response.data.subdomain);
                    if(response.data.isPaymentDone === false){
                        if (response.data.isFreePlan === false) {
                            showSweetAlert(
                                'Warning!',
                                `Your plan has expired. Please select a plan after logging in.`,
                                'warning'
                            );
                        }
                        // showSweetAlert('Warning!', `Your plan has expired. Please select a plan after logging in.`, 'warning');
                        navigate('/demo');
                    }
                    else{
                        navigate('/Home/Landing');
                    }
                } 
                // if(response.data.isPaymentDone === false){
                //     navigate('/demo');x
                // }
                // else{
                //     navigate('/Home/Landing');
                //     // navigate('/pricing-plans', { state: { email: data.userEmail, name: userName } });
                // }
            } else {
                // Handle case where API response indicates invalid credentials
                setErrors({ ...errors, invalid: data.message || 'Invalid email or password.' });
            }
        } catch (error) {
            // Check if the error response exists and contains a message
            if (error.response && error.response.data) {
                setErrors({ ...errors, invalid: error.response.data.message || 'Invalid email or password.' });
            } else {
                setErrors({ ...errors, invalid: 'Failed to login. Please try again later.' });
            }
        } finally {
            setLoading(false); // Reset loading state after API call
        }
    };

    const handleShowPolicy = () => {
        setShowPolicy(true);
    };

    const handleHidePolicy = () => {
        setShowPolicy(false);
    };

    return (
        <>
        <div className="login-container">
            {showPolicy ? (
                <Policy handleClose={handleHidePolicy} />
            ) : (
                <Card className="login-card gradient-border">
                    <Card.Body>
                        <div className="text-center mb-5 mt-2">
                            <img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="App-logo" alt="logo" />
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formBasicEmail" className="floating-label-group">
                                <Form.Control
                                    type="email"
                                    className="form-input"
                                    placeholder=" "
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                />
                                <label className={email ? 'floating-label float' : 'floating-label'}>Email</label>
                            </Form.Group>
                            {errors.email && <div className="text-danger mt-1">{errors.email}</div>}
                            <Form.Group controlId="formBasicPassword" className="mt-3 floating-label-group">
                                <div className="password-wrapper">
                                    <Form.Control
                                        type={passwordShown ? 'text' : 'password'}
                                        className="form-input"
                                        placeholder=" "
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <label className={password ? 'floating-label float' : 'floating-label'}>Password</label>
                                    <span className="toggle-password" onClick={togglePasswordVisibility}>
                                        {passwordShown ? <img src={`${process.env.PUBLIC_URL}/images/eye_visible.png`} alt="eye" /> : <img src={`${process.env.PUBLIC_URL}/images/eye_hide.png`} alt="eye" />}
                                    </span>
                                </div>
                            </Form.Group>
                            {errors.password && <div className="text-danger mt-1">{errors.password}</div>}
                            {errors.invalid && <div className="text-danger mt-1">{errors.invalid}</div>}
                            <div className="d-flex justify-content-between align-items-center mt-2">
                                <Link to="/forgot-password" state={{ email }} className="forgot-password">Forgot password?</Link>
                            </div>
                            <div>
                                <Button 
                                    variant="primary" 
                                    type="submit" 
                                    className="mt-3 w-100 p-2 theme-btn"
                                    disabled={loading} // Disable button if loading
                                >
                                    {loading ? "Logging In..." : "Log In"} {/* Change button text based on loading state */}
                                </Button>
                                <div className="text-center mt-3">
                                    <span className="privacy-policy" role="button" onClick={handleShowPolicy}>Privacy policy</span>
                                </div>
                                <div className="text-center mt-3">
                                    <Link to="/signup" className="forgot-password"> <span style={{color: "#FFFFFF"}}>Don't have an account?</span> Sign up</Link>
                                </div>
                                
                            </div>
                            <div className="text-center">
                                <Button hidden={!showContactUs}
                                    variant="primary" 
                                    type="button" 
                                    className="p-2"
                                    onClick={handleShowSupport}
                                >
                                    {"Contact Us"}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            )}
        </div>

        <Modal show={showSupport} onHide={handleCloseSupport} centered >
            <Modal.Body className="support-dialog">
            <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={handleCloseSupport} />
            <h6 className="large-text">Hello {name}! <br />How can we help you today?</h6>
            <Form onSubmit={handleSupportSubmit} className="basic-form">
                <Form.Group>
                <Form.Control
                    as="select"
                    className="form-input custom-select mt-4" // Apply custom CSS class
                    value={issueType}
                    onChange={(e) => {
                    setIssueType(e.target.value);
                    if (e.target.value) {
                        setSupportErrors((prevErrors) => ({ ...prevErrors, issueType: '' })); // Remove error
                    }
                    }}
                >
                    <option value="">Select your type of issue</option>
                    <option value="General Issues">General Issues</option>
                    <option value="Technical Issues">Technical Issues</option>
                    <option value="Misc. Support Issues">Misc. Support Issues</option>
                </Form.Control>
                </Form.Group>
                {supporterrors.issueType && <div className="text-danger mt-1">{supporterrors.issueType}</div>}

                <Form.Group>
                <Form.Control
                    as="textarea"
                    className="form-input mt-4 support-desc"
                    placeholder="Description"
                    value={description}
                    rows={4}
                    onChange={(e) => {
                    setDescription(e.target.value);
                    if (e.target.value.trim()) {
                        setSupportErrors((prevErrors) => ({ ...prevErrors, description: '' })); // Remove error
                    }
                    }}
                />
                </Form.Group>
                {supporterrors.description && <div className="text-danger mt-1">{supporterrors.description}</div>}

                <div className="row justify-content-center submit-btn">
                <button type="submit" className="w-55 p-2 theme-btn btn-primary" style={{ color: "#FFF", border: "unset" }}>Submit</button>
                </div>
            </Form>
            </Modal.Body>
        </Modal>
        </>
    );
};

export default Login;
